import { render, staticRenderFns } from "./QuestionTypeSelect.vue?vue&type=template&id=588cab36"
import script from "./QuestionTypeSelect.vue?vue&type=script&lang=js"
export * from "./QuestionTypeSelect.vue?vue&type=script&lang=js"
import style0 from "./QuestionTypeSelect.vue?vue&type=style&index=0&id=588cab36&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports